import RsaRiepiloghi from "../index";

const routes = [
  {
    name: "RsaRiepiloghi",
    path: "/rsariepiloghi",
    component: RsaRiepiloghi.RsaRiepiloghiPage,
    meta: { title: "R.S.A. - Riepiloghi" },
  },
  {
    name: "RsaRiepilogoVociDiarioList",
    path: "/riepilogovocidiario",
    component: RsaRiepiloghi.RsaRiepilogoVociDiarioListPage,
    meta: { title: "R.S.A. - Riepilogo Voci Diario" },
  },
  
];

export default routes;